import { methodGet, methodPatch, methodPost } from './api/methods';

export const getAllVideosubs = (token) => {
  return methodGet('videosub/all', '', token);
};

export const getVideosubById = (id, token) => {
  return methodGet('videosub/' + id, '', token);
};

export const getVideosubByQuery = (req, token) => {
  return methodGet('videosub', req, token);
};

export const createVideosub = (data, token) => {
  return methodPost('videosub/create', data, token);
};

export const patchVideosub = (id, data, token) => {
  return methodPatch('videosub/update?id=' + id, data, token);
};
